import { FaWindowClose } from 'react-icons/fa';
import React, { FC } from 'react';
import { IconProps } from './common/iconProps';

export const ForbiddenIcon:
FC<IconProps> = ({ className }) => <FaWindowClose className={className} />;
